  /*=========================================================================================
  File Name: mutations.js
  Description: Order Manager State Module
  ----------------------------------------------------------------------------------------
  Item Name: Fuji Sushi App
  Author: Tan Tran
==========================================================================================*/
import moment from 'moment'
export default {
    SET_ORDER_MANAGER_STATE(state, payload) {
        state.capacity = payload.capacity,
        state.currentWaitingTime = payload.currentWaitingTime,
        state.minWaitingTime = payload.minWaitingTime,
        state.maxWaitingTime = payload.maxWaitingTime,
        state.cannotOrderNow = payload.cannotOrderNow,
        state.increaseTimeStep = payload.increaseTimeStep,
        state.pendingOrdersIncreaseStep = payload.pendingOrdersIncreaseStep,
        state.initTimeOfOrder = payload.initTimeOfOrder,
        state.offTime = moment(payload.offTime, 'HH:mm')
    },

    SET_CURRENT_WAITING_TIME_STATE (state, payload) {
        state.currentWaitingTime = payload;
    },
}